module.exports = __webpack_public_path__ + "media/images/landing/home/categories/conferences-bd663aa221cf4ab196a419c3b408a788.png";